import{styled as i}from"@mui/material/styles";const a=i("div")((({theme:i})=>({padding:i.spacing(8,0),[i.breakpoints.down("sm")]:{padding:i.spacing(6,0)}})));export{a as PressMediaArticleCardContainer};
//# sourceMappingURL=styles.js.map
